<template>
  <div class="coverage-select">
    <label v-if="label" class="coverage-select__label" :for="selectId">
      {{ label }}
    </label>
    <el-select
      :id="selectId"
      :value="value"
      class="coverage-select__el"
      @change="$emit('input', $event)"
    >
      <el-option
        v-for="(item, idx) in offers"
        :key="item.offerId"
        :value="idx"
        :label="format(item.coverage)"
      />
    </el-select>
  </div>
</template>

<script>
export default {
  name: 'MiniKaskoCoverageSelect',
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    value: {
      type: Number,
      default: 0,
    },
    offers: {
      type: Array,
      required: true,
    },
    label: {
      type: String,
      default: 'Покриття',
    },
    selectId: {
      type: String,
      default: null,
    },
  },
  methods: {
    format(coverage) {
      if (coverage == null) return 'Не вказано';
      return Number(coverage).toLocaleString('uk-UA') + ' грн';
    },
  },
};
</script>

<style lang="scss" scoped>
.coverage-select {
  display: flex;
  flex-direction: column;
  gap: 6px;

  &__label {
    color: #717680;
    font-size: 14px;
    line-height: 1.43;
    white-space: nowrap;
  }

  @media (max-width: 640px) {
    flex-direction: row;
    align-items: center;

    &__label {
      flex: 0 0 auto;
    }

    &__el {
      flex: 1 1 0;
      min-width: 0;
    }
  }

  &__el {
    width: 100%;

    ::v-deep .el-input__inner {
      height: 48px;
      line-height: 48px;
      border: 1px solid #cbd5e1;
      border-radius: 8px;
      background: #f8fafc;
      color: #0f172a;
      font-size: 18px;
      font-weight: 600;
      font-family: inherit;
      padding-left: 14px;
      transition: border-color 0.2s ease, background-color 0.2s ease;

      &:hover {
        border-color: #93c5fd;
        background: #f0f7ff;
      }
    }

    ::v-deep .el-input.is-focus .el-input__inner,
    ::v-deep .el-input__inner:focus {
      border-color: #3b82f6;
      background: #ffffff;
      box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.12);
    }

    ::v-deep .el-select__caret {
      color: #0a77ff;
    }
  }
}
</style>
